<template>
<div class="vertical-align-wrap">
  <div class="vertical-align-middle auth-main">
    <div class="auth-box">
      <div class="top">
        <img src="../assets/img/logo.svg" alt="UOI">
      </div>
      <div class="card">
        <div id="loading" v-if="isHidden">
          <div v-if="isHidden" class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
          <div v-if="isHidden">Sending Email... Please Wait</div>
        </div>
        <div v-if="!isHidden" class="col-sm-12">
          <div class="header">
            <p class="lead">Please enter your email</p>
          </div>
          <div class="body">
            <div class="form-group">
              <label for="signin-email" class="control-label sr-only">Email</label>
              <input type="email" class="form-control" id="signin-email" placeholder="Email" v-model="body.email">
            </div>
            <button class="btn btn-primary btn-lg btn-block" v-on:click="isHidden = true" @click="save">Reset my password via Email</button>
            <button class="btn btn-primary btn-lg btn-block" @click="backToLogin">Bring me back to Login</button>
            <!-- <div class="bottom">
              <span class="helper-text m-b-10"><i class="fa fa-lock"></i> <a href="page-forgot-password.html">Forgot password?</a></span>
              <span>Don't have an account? <router-link to="" @click.native="signup">Register</router-link></span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import api from '../services/api'
import { prettifyErrorMessage } from '../utils'
import { Login } from '../models/login'
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      body: {email: ''},
      isHidden: false,
      listErr: []
    }
  },
  methods: {
    ...mapActions(['appLogin']),
    async save() {
      this.validate()

      if(this.listErr.length > 0) {
        this.showValidationError()
        return
      }

      const signUpApi = api('member-management/request-reset-password')
      await signUpApi.create(this.body)
      this.$router.go(-1)
    },
    backToLogin() {
      this.$router.push({ name: 'login' })
    },
    validate() {
      if(this.body.email === '') this.listErr.splice(this.listErr.length, 0, 'Please input your Email address !')
    },
    showValidationError() {
      Vue.notify({
        group: 'appNotif',
        title: 'Validation errors',
        text: prettifyErrorMessage(this.listErr),
        type: 'error'
      })
    },
  }
}
</script>